import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
const faqs = [{
  q: 'How long does the protocol take?',
  a: "Exactly 22 minutes if you follow the templates. It's designed for busy, tired people."
}, {
  q: 'Is this a digital product?',
  a: 'Yes. You get instant access to the PDF tools and templates to use on your phone, tablet, or to print out.'
}, {
  q: 'What if I have ADHD?',
  a: 'This kit is actually ideal for ADHD brains because it reduces "Choice Paralysis" and breaks everything down into micro-decisions.'
}, {
  q: 'Do I need any special apps?',
  a: "No. Just the PDF and a pen (or your phone's note app)."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-20 md:py-28 px-6" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-serif text-forest mb-12 text-center" data-id="element-36">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4" data-id="element-37">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden border border-sage/20 shadow-sm" data-id="element-38">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-39">
                  <span className="font-serif text-lg text-forest pr-8" data-id="element-40">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-41" />
                </button>

                <AnimatePresence data-id="element-42">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-43">
                      <div className="px-6 pb-6 text-charcoal/80 font-light border-t border-cream pt-4" data-id="element-44">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}